import React from 'react'
import LoadingItem from './loading-item'

class Loader extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      items: props.items,
      type: props.type
    }
  }

  listedItems() {
    const items = [];

    for (let i = 0; i < this.state.items; i++) {
      items.push(<LoadingItem key={i.toString()} type={this.state.type} />);
    }
    return items;
  }

  render() {
    return this.listedItems()
  }
}

export default Loader;
